var map = {
	"./adam.svg": "6295",
	"./andrew_ashley.svg": "9294",
	"./dan.svg": "3d6f",
	"./dede.svg": "ab78",
	"./frank.svg": "55bc",
	"./gail_alex.svg": "bbcc",
	"./gerry_anne.svg": "70a1",
	"./heather.svg": "8941",
	"./lisa.svg": "185e",
	"./steve_anna.svg": "fa71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "239e";